
























































/** Принятые цены конкурента относятся ко всему кластеру, а не к одной торговой точке */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import MmHintedButton from '../../components/MmHintedButton.vue';
import { MM_EMPTY_DASH } from '../../core/format';
import { MmMonitoringBatch } from './batch';

const KEY_PREFIX = 'priceMonitoring.mobileMonitoring.results.';

@Component({
	components: { MmHintedButton },
})
export default class AcceptMonitoringDialog extends Vue {
	@Prop({ default: false }) readonly visible!: boolean;

	@Prop({ default: null }) readonly batch!: MmMonitoringBatch | null;

	@Prop({ default: 0 }) readonly acceptedTotal!: number;

	/** null — секция число не передала: на его месте прочерк, а не ноль и не число принятых */
	@Prop({ default: null }) readonly resultsTotal!: number | null;

	@Prop({ default: false }) readonly busy!: boolean;

	get titleText(): string {
		return this.$t(KEY_PREFIX + 'acceptTitle') as string;
	}

	get confirmText(): string {
		return this.$t(KEY_PREFIX + 'acceptButton') as string;
	}

	get confirmQuestionText(): string {
		return this.$t(KEY_PREFIX + 'acceptConfirm') as string;
	}

	get cancelText(): string {
		return this.$t('shared.actions.cancel') as string;
	}

	get cancelDisabledReason(): string {
		return this.$t(KEY_PREFIX + 'acceptRunning') as string;
	}

	get countsText(): string {
		return this.$t(KEY_PREFIX + 'acceptCounts', {
			count: this.safeCount(this.acceptedTotal),
			total: this.totalText,
			tasks: this.tasksTotal,
			competitors: this.competitorCodes.length,
		}) as string;
	}

	get tasksLabel(): string {
		return this.$t(KEY_PREFIX + 'summaryTasks') as string;
	}

	get competitorsLabel(): string {
		return this.$t(KEY_PREFIX + 'summaryCompetitors') as string;
	}

	get onlyAcceptedText(): string {
		return this.$t(KEY_PREFIX + 'acceptOnlyAccepted') as string;
	}

	get clusterWarningText(): string {
		return this.$t(KEY_PREFIX + 'acceptClusterWarning', { cluster: this.clusterText }) as string;
	}

	get spNoticeText(): string {
		return this.$t(KEY_PREFIX + 'acceptSpNotice') as string;
	}

	get totalText(): string {
		if (this.resultsTotal === null || this.resultsTotal === undefined) {
			return MM_EMPTY_DASH;
		}

		return typeof this.resultsTotal === 'number' && !isNaN(this.resultsTotal)
			? String(this.resultsTotal)
			: MM_EMPTY_DASH;
	}

	get clusterText(): string {
		if (this.batch === null) {
			return MM_EMPTY_DASH;
		}

		const name = this.batch.storeClusterName;

		if (name === null || name === undefined || String(name).trim() === '') {
			return MM_EMPTY_DASH;
		}

		return String(name).trim();
	}

	get tasksTotal(): number {
		return this.batch === null ? 0 : this.batch.tasksTotal;
	}

	get competitorCodes(): string[] {
		return this.batch === null ? [] : this.batch.competitorCodes;
	}

	get hasCompetitors(): boolean {
		return this.competitorCodes.length > 0;
	}

	/** Гасим повторное нажатие явно: у кнопки ant loading не выставляет disabled */
	handleConfirm(): void {
		if (this.busy) {
			return;
		}

		this.$emit('confirm');
	}

	handleCancel(): void {
		if (this.busy) {
			return;
		}

		this.$emit('cancel');
	}

	@Watch('visible')
	onVisibleChange(next: boolean): void {
		if (!next || process.env.NODE_ENV === 'production') {
			return;
		}

		if (this.resultsTotal === null || this.resultsTotal === undefined) {
			// eslint-disable-next-line no-console
			console.warn(
				'[AcceptMonitoringDialog] проп resultsTotal не передан: во фразе' +
					' «Будет принято позиций: N из M» вместо M будет прочерк.',
			);
		}
	}

	private safeCount(value: number): number {
		return typeof value === 'number' && !isNaN(value) ? value : 0;
	}
}
